import { isAlphaProjectId } from "./isProductionDeployment";

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);
const BASE_NAME = "ViewSpark Admin";

export function adminDocumentTitles(
  hostname: string | undefined,
  projectId?: string | null
): { titleTemplate: string; defaultTitle: string } {
  const host = (hostname || "").trim().toLowerCase();
  let prefix = "";
  if (LOCAL_HOSTS.has(host)) {
    prefix = "[L] ";
  } else if (isAlphaProjectId(projectId)) {
    prefix = "[A] ";
  }
  const defaultTitle = `${prefix}${BASE_NAME}`;
  return {
    defaultTitle,
    titleTemplate: `${defaultTitle} - %s`,
  };
}
